module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ec9bbbe4cd938247ffa7bbfb34455ca7.png";